const removeNegativeSign = (value) => {
  if (typeof value === 'number') {
    return Math.abs(value);
  } else if (typeof value === 'string') {
    return value.replace(/-/g, ''); // Use regular expression to remove all minus symbols
  }
  return value;
}

const parseLengthUnitInCm = (value, unit) => {
  if(!value || ['None', '0', '0.0', '0.00'].includes(value)) return '0';
  value = parseFloat(value);
  switch(unit) {
    case 'cm': 
    break;
    case 'm': value *= 100;
    break;
    case 'in': value *= 2.54;
    break;
    case 'ft': value *= 30.48;
    break;
    case 'yd': value *= 91.44;
    break;
  }
  return value.toString();
}

export { removeNegativeSign, parseLengthUnitInCm }